export const giftRefundPtBR = {
  action: "Reembolsar",
  title: "Reembolsar Gift Cards",
  eligibility: "Reembolse somente as unidades disponíveis neste estoque. Unidades disponibilizadas na loja ou entregues a alunos não estão incluídas.",
  quantity: "Quantidade a reembolsar",
  available: "{{count}} unidade(s) disponível(is)",
  credit: "Crédito a receber",
  destination: "O valor será creditado na carteira Gamefik desta conta para novas compras. Não é um estorno no cartão, Pix ou boleto.",
  confirm: "Confirmar reembolso",
  submitting: "Reembolsando...",
  changed: "O estoque ou valor mudou. Revise a quantidade e o crédito antes de confirmar novamente.",
  loadFailed: "Não foi possível atualizar o estoque. Nenhum reembolso foi solicitado. Tente novamente.",
  failed: "Não foi possível reembolsar. Atualize o estoque e revise a quantidade antes de tentar novamente.",
  uncertain: "A resposta não chegou. Verifique novamente para retomar este mesmo reembolso sem duplicar o crédito.",
  retry: "Verificar reembolso",
  success: "Reembolso concluído. O crédito foi adicionado à carteira Gamefik.",
};

export const giftRefundEnUS = {
  action: "Refund",
  title: "Refund Gift Cards",
  eligibility: "Refund only units available in this stock. Units listed in the store or delivered to students are not included.",
  quantity: "Quantity to refund",
  available: "{{count}} unit(s) available",
  credit: "Credit to receive",
  destination: "The amount will be credited to this account's Gamefik wallet for new purchases. It is not a refund to your card, Pix or bank slip.",
  confirm: "Confirm refund",
  submitting: "Refunding...",
  changed: "The stock or value changed. Review the quantity and credit before confirming again.",
  loadFailed: "Could not refresh stock. No refund was requested. Try again.",
  failed: "Could not refund. Refresh stock and review the quantity before trying again.",
  uncertain: "The response did not arrive. Check again to resume this same refund without duplicating the credit.",
  retry: "Check refund",
  success: "Refund completed. Credit was added to your Gamefik wallet.",
};

export const giftRefundEsES = {
  action: "Reembolsar",
  title: "Reembolsar Gift Cards",
  eligibility: "Reembolsa solo las unidades disponibles en este stock. Las unidades publicadas en la tienda o entregadas a alumnos no están incluidas.",
  quantity: "Cantidad a reembolsar",
  available: "{{count}} unidad(es) disponible(s)",
  credit: "Crédito a recibir",
  destination: "El importe se acreditará en la billetera Gamefik de esta cuenta para nuevas compras. No es una devolución a la tarjeta, Pix o boleto.",
  confirm: "Confirmar reembolso",
  submitting: "Reembolsando...",
  changed: "El stock o el importe cambió. Revisa la cantidad y el crédito antes de confirmar de nuevo.",
  loadFailed: "No se pudo actualizar el stock. No se solicitó ningún reembolso. Inténtalo de nuevo.",
  failed: "No se pudo reembolsar. Actualiza el stock y revisa la cantidad antes de intentarlo de nuevo.",
  uncertain: "No llegó la respuesta. Comprueba de nuevo para retomar este mismo reembolso sin duplicar el crédito.",
  retry: "Comprobar reembolso",
  success: "Reembolso completado. Se añadió el crédito a la billetera Gamefik.",
};
